import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  ConfigurationsFormGroup,
  DeliveryCountdownTimerFormGroup,
  ExpirationBehavior,
  ShippingMethodSelectionType,
  TimeUnit,
} from '../../models';

@Component({
  selector: 'delivery-countdown-timer-form-configurations',
  templateUrl: './delivery-countdown-timer-form-configurations.component.html',
  styleUrl: './delivery-countdown-timer-form-configurations.component.scss',
  standalone: false,
})
export class DeliveryCountdownTimerFormConfigurationsComponent {
  @Input() formGroup: FormGroup<DeliveryCountdownTimerFormGroup>;
  @Input() set shippingMethods(value: Array<{ id: number; name: string }>) {
    this._shippingMethods = value || [];
    this._shippingMethodOptions = this._shippingMethods.map((method) => ({
      label: method.name || 'Unknown',
      value: method.id,
    }));
  }
  get shippingMethods(): Array<{ id: number; name: string }> {
    return this._shippingMethods;
  }
  private _shippingMethods: Array<{ id: number; name: string }> = [];
  private _shippingMethodOptions: Array<{ label: string; value: number }> = [];
  private readonly _expirationBehaviorOptions: Array<{ label: string; value: ExpirationBehavior }> = [
    { label: 'Timer disappears', value: ExpirationBehavior.TIMER_DISAPPEARS },
    { label: 'Show fallback message', value: ExpirationBehavior.SHOW_FALLBACK_MESSAGE },
  ];
  private readonly _timeUnitOptions: Array<{ label: string; value: TimeUnit }> = [
    { label: 'Min', value: TimeUnit.MINUTES },
    { label: 'Hour', value: TimeUnit.HOURS },
  ];

  ShippingMethodSelectionType = ShippingMethodSelectionType;
  TimeUnit = TimeUnit;
  ExpirationBehavior = ExpirationBehavior;

  get shippingMethodOptions(): Array<{ label: string; value: number }> {
    return this._shippingMethodOptions;
  }

  get expirationBehaviorOptions(): Array<{ label: string; value: ExpirationBehavior }> {
    return this._expirationBehaviorOptions;
  }

  get timeUnitOptions(): Array<{ label: string; value: TimeUnit }> {
    return this._timeUnitOptions;
  }

  get configurationsGroup(): FormGroup<ConfigurationsFormGroup> {
    return this.formGroup.get('configurations') as FormGroup<ConfigurationsFormGroup>;
  }

  get showFallbackMessageInput(): boolean {
    return this.configurationsGroup.get('expirationBehavior')?.value === ExpirationBehavior.SHOW_FALLBACK_MESSAGE;
  }

  get showShippingMethodDropdown(): boolean {
    return this.configurationsGroup.get('shippingMethodSelectionType')?.value === ShippingMethodSelectionType.MANUAL;
  }
}
